import { WEB_LINKS } from "../webLinks";
import { TranslationKeys } from "../../types/i18n";

export const enTranslations = {
  common: {
    continue: "Continue",
    cancel: "Cancel",
    done: "Done",
    back: "Back",
    next: "Next",
    submit: "Submit",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    retry: "Retry",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    search: "Search",
    verify: "Verify",
    ok: "OK",
    close: "Close",
    welcome: "Welcome",
    noContentAvailable: "No content available.",
    home: "Home",
    scrollToBottomToAccept: "Scroll to the bottom to accept",
    open: "Open",
    saveShare: "Save/Share",
    downloadSuccessTitle: "Download success",
    monthJanuary: "January",
    monthFebruary: "February",
    monthMarch: "March",
    monthApril: "April",
    monthMay: "May",
    monthJune: "June",
    monthJuly: "July",
    monthAugust: "August",
    monthSeptember: "September",
    monthOctober: "October",
    monthNovember: "November",
    monthDecember: "December",
  },
  accessibility: {
    carouselPrevious: "Previous image",
    carouselNext: "Next image",
  },

  auth: {
    login: "Sign In",
    signIn: "Sign in",
    loginSubtitle: "Choose your preferred login method",
    loginWithEmail: "Login with Email",
    continueWithEmail: "Continue with email",
    welcomeBack: "Welcome back!",
    loginToAccessProperties: "Login to access your properties",
    signInToAccessProperties: "Sign in to access your properties",
    register: "Sign Up",
    loginDescription: "Please enter your email and password",
    newOnBloom: "New on Bloom?",
    logout: "Logout",
    email: "Email",
    emailId: "Email ID",
    password: "Password",
    forgotPassword: "Forgot password",
    forgotPasswordDescription:
      "Please enter your registered email id. We'll send the OTP to reset password via email",
    sendResetLink: "Request OTP",
    passwordSentTitle: "We have sent the password to your email",
    passwordSentDescription:
      "Login with the password sent to {email} and reset password",
    backToLogin: "Back to Login",
    enterEmailId: "Enter email id",
    enterPassword: "Enter password",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    invalidEmail: "Please enter a valid email address",
    loginError: "Invalid email or password. Please try again.",
    sessionExpired: "Your session has expired.",
    deviceIdMismatch: "Another device has logged in. Please log in again.",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    loginWithUAEPass: "Login with UAE PASS",
    registerWithUAEPass: "Register with UAE Pass",
    registerWithEmiratesID: "Register with Emirates ID",
    registerWithPassport: "Register with Passport",
    uaePassLogin: "Login with UAE PASS",
    emiratesIdRegistration: "Register with Emirates ID",
    passportRegistration: "Register with Passport",
    continueWithUAEPass: "Continue with UAE PASS",
    continueAsGuest: "Continue as Guest",
    continueWithEmiratesID: "Continue with Emirates ID",
    continueWithPassport: "Continue with Passport",
    loginWithEmiratesIDButton: "Login with Emirates ID",
    verifyIdentity: "Verify your identity",
    mobileVerificationSent:
      "We've sent a 4-digit verification code to your registered mobile number",
    emailVerificationSent:
      "We've sent a 4-digit verification code to your registered email Id",
    didntReceiveCode: "Didn't receive the code?",
    noAccessToPhone: "Don't have access to this phone no.",
    raiseSupportTicket: "Raise Support Ticket",
    verifyAndContinue: "Verify & Continue",
    resendOTP: "Resend OTP",
    resendOTPTimer: "Resend OTP in {resendTimer}",
    emiratesId: "Emirates ID",
    emiratesIdInputPlaceholder: "xxxx - xxxx - xxxx",
    invalidEmiratesId: "Please enter a valid Emirates ID.",
    continue: "Continue",

    verify: "Verify",
    emiratesIdPlaceholder: "784 - Enter emirates id",
    registrationSuccessful: "Registration Successful!",
    registrationWasSuccessful: "Your registration was successful!",
    setupPasswordToComplete:
      "Setup your password to complete the setup and access your properties",
    almostThere:
      "Almost there, just login via UAE Pass to access your properties",
    registrationRequestSubmitted:
      "Registration request submitted successfully!",
    weWillConfirmDetails:
      "We'll confirm the details and notify you once access is ready.",
    registrationAttemptFailed: "Your registration attempt has failed",
    tryRegisteringAgain:
      "Please try registering again or contact customer support.",
    setupPasscode: "Setup passcode",
    uaePassSuccess: "UAE Pass Authentication Successful",
    uaePassError: "UAE Pass Authentication Error",
    newPassword: "New password",
    changePassword: "Change password",
    setNewPassword: "Set a new password",
    enterNewPassword: "Enter new password",
    enterNewPasswordTitle: "Enter new password",
    pleaseEnterNewPassword: "Please enter new password",
    enterCurrentPassword: "Enter current password",
    enterCurrentPasswordTitle: "Enter current password",
    pleaseEnterCurrentPassword:
      "Please enter your current password to continue",
    confirmNewPassword: "Confirm new password",
    passwordMatches: "Password matches",
    passwordChangedSuccessfully: "Password has been changed",
    passwordSameAsCurrent:
      "New password and current password cannot be the same",
    changePasswordConfirmationTitle:
      "Are you sure you want to change password?",
    changePasswordConfirmationMessage:
      "An email will be sent to your registered address to reset your account password.",
    passwordRuleCapital: "1 capital letter",
    passwordRuleSmall: "1 small letter",
    passwordRuleNumber: "1 number",
    passwordRuleSymbol: "1 symbol",
    adhaUaePass: {
      processing: "Processing",
      userCancelledLogin: "User Cancelled the login",
      somethingWentWrong:
        "Something went wrong during the login, Please try again later!",
      sop1: "You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact Bloom Partners to access the services.",
      userNotRegistered:
        "This Service is only for registered users, please contact Bloom ADHA in order to access the services.",
      missingCode: "Unable to complete UAE PASS login. Please try again.",
      errorInvalidSession:
        "Something went wrong during the login, Please try again later!",
      errorGeneric:
        "Something went wrong during the login, Please try again later!",
    },
  },

  otp: {
    verifyPhoneNumber: "Verify phone number",
    verifyEmail: "Change communication email ID",
    changePhoneNumber: "Change phone number",
    changeCommunicationEmail: "Change communication email ID",
    changeLoginEmail: "Change login email ID",
    verifyPhoneDescription:
      "Verifying your phone number helps us confirm your identity and prevent unauthorised access.",
    verifyEmailDescription:
      "Verifying your mail id helps us confirm your identity and prevent unauthorised access.",
    enterOTP: "Please enter OTP received on {contact}",
    enterPhoneForOTP: "Please enter your phone number to receive OTP",
    enterEmailForOTP: "Please enter your email id to receive OTP",
    resendOTP: "Resend OTP",
    resendOTPTimer: "Resend OTP in {resendTimer}",
    otpSent: "OTP sent successfully",
    otpVerified: "OTP verified successfully",
    invalidOTP: "Invalid OTP",
    invalidOTPPleaseTryAgain: "Invalid OTP. Please try again.",
    otpExpired: "OTP expired. Tap Resend OTP to get a new one.",
    pasteOTP: "Paste OTP",
    requestOtp: "Request OTP",
  },

  welcome: {
    welcomeTitle: "Welcome to the Future of Real Estate",
    heroTitle: "Your Property, Simplified",
    heroSubtitle:
      "Manage your Bloom properties, track payments, and stay updated on property progress with our intelligent platform.",
    downloadApp: "Get app to register",
    login: "Login",
    welcomeTo: "Welcome to",
    appName: "Bloom Holding",
    subtitle1: "Everything you need to manage your properties in one place.",
    uaeCitizenResident: "UAE Citizen/Resident",
    internationalUser: "International User",
    chooseYourPath: "Tell us who you are to get started",
    registerTitle: "Sign Up",
    registerSubtitle: "Tell us who you are to get started",
    uaeRegistrationTitle: "UAE Citizen/Resident Sign Up",
    uaeRegistrationSubtitle:
      "To continue, please register with UAE PASS or Emirates ID to view your property details.",
    internationalRegistrationTitle: "International user Sign Up",
    internationalRegistrationSubtitle:
      "Use your passport to register and unlock access to your property.",
    uaeMethodsTitle: "UAE Citizen/Resident Sign Up",
    uaeMethodsSubtitle:
      "To continue, please register with UAE PASS or Emirates ID to view your property details.",
    registerWithUaePass: "Sign up with UAE PASS",
    registerWithEmiratesId: "Sign up with Emirates ID",
    internationalMethodsTitle: "International user Sign Up",
    internationalMethodsSubtitle:
      "Use your passport to register and unlock access to your property.",
    registerWithPassport: "Sign Up with Passport",
    faqSupport: "FAQ & support",
    or: "OR",
  },
  webHome: {
    featuresPill: "Features",
    featuresTitle: "Everything you need to manage your real estate portfolio",
    featuresSubtitle:
      "From property tracking to payment management, our platform provides all the tools you need in one beautiful, easy-to-use interface.",
    featuresPropertyManagementTitle: "Property management",
    featuresPropertyManagementBody:
      "Track your properties, monitor construction progress, and manage all aspects of your real estate portfolio.",
    featuresPaymentTrackingTitle: "Payment Tracking",
    featuresPaymentTrackingBody:
      "Stay on top of all payments, fees, and financial obligations with real-time alerts and notifications.",
    featuresSecurePlatformTitle: "Secure Platform",
    featuresSecurePlatformBody:
      "Your data is protected with enterprise-grade security and encryption technologies.",
    mobilePill: "Mobile Experience",
    mobileTitle: "Manage your Bloom properties on the go",
    mobileSubtitle:
      "Our mobile-first design ensures you access your property information, track payments, and receive updates wherever you are.",
    mobileBullet1: "Real-time construction progress updates",
    mobileBullet2: "Instant payment alerts and notifications",
    mobileBullet3: "Secure document access",
    mobileBullet4: "Quick customer support",
    mobileCta: "Get the app",
    mobileToast1Title: "Payment Confirmed",
    mobileToast1Body: "Your payment of AED 110,000 has been received",
    mobileToast2Title: "Construction Update",
    mobileToast2Body: "Your property A1-401 Bloom Central is now 75% complete",
    testimonialsPill: "Testimonials",
    testimonialsTitle: "Trusted by thousands of property investors",
    testimonialsSubtitle:
      "See what our customers have to say about their experience with Bloom.",
    testimonialsCard1Body:
      '"Bloom has transformed how I manage my real estate investments. The payment tracking feature alone has saved me countless hours."',
    testimonialsCard1Name: "Ahmed Al-Mansouri",
    testimonialsCard1Role: "Property Investor",
    testimonialsCard2Body:
      '"The construction progress updates give me peace of mind. I always know exactly how my new home is progressing."',
    testimonialsCard2Name: "Sarah Johnson",
    testimonialsCard2Role: "First-time Buyer",
    testimonialsCard3Body:
      '"My clients love the transparency and real-time updates. It\'s made my job so much easier."',
    testimonialsCard3Name: "Mohammed Hassan",
    testimonialsCard3Role: "Real Estate Agent",
    ctaTitle: "Ready to revolutionize your\nreal estate experience?",
    ctaSubtitle:
      "Join thousands of property investors who trust Bloom to manage their real estate portfolio.",
    ctaButton: "Contact sales",
    footerAbout:
      "Bloom Holding is a leading UAE-based developer specializing in real estate, education, and hospitality, with projects across the UAE and internationally. We focus on creating inclusive communities, operates luxury hotels, and manages prestigious schools, while expanding its footprint with new developments like Mabel Marbella Residences in Spain.",
    footerProjectsHeading1: "OUR PROJECTS",
    footerProjectsItem1: "Property - Leasing",
    footerProjectsItem2: "Property - Sales",
    footerProjectsItem3: "Aldhay",
    footerProjectsItem4: "Bloom Arjaan by Rotana",
    footerProjectsItem5: "Soho Square",
    footerProjectsHeading2: "",
    footerProjectsItem6: "Bloom Central",
    footerProjectsItem7: "Bloom Gardens",
    footerProjectsItem8: "Bloom Heights",
    footerProjectsItem9: "Bloom Living Abu Dhabi",
    footerProjectsItem10: "Rochester, USA",
    footerContactHeading: "CONTACT US",
    footerContactPhone1: "800 Bloom (25666)",
    footerContactPhone2: "(Outside UAE) +971 2 696 9500",
    footerContactEmail: "customerservice@bloomholding.com",
    footerContactTwitter: "Twitter",
    footerContactFacebook: "Facebook",
    footerContactInstagram: "Instagram",
    footerContactLinkedIn: "LinkedIn",
    footerContactTikTok: "TikTok",
    footerContactYouTube: "YouTube",
    footerContactTwitterUrl: WEB_LINKS.TWITTER,
    footerContactFacebookUrl: WEB_LINKS.FACEBOOK,
    footerContactInstagramUrl: WEB_LINKS.INSTAGRAM,
    footerContactLinkedInUrl: WEB_LINKS.LINKEDIN,
    footerContactTikTokUrl: WEB_LINKS.TIKTOK,
    footerContactYouTubeUrl: WEB_LINKS.YOUTUBE,
    documentAppName: "Bloom Holding",
    documentDescription:
      "Manage your Bloom properties, track payments, and stay updated on property progress with our intelligent platform.",
    documentHome: "Explore Bloom World",
    documentWelcome: "Welcome to the Future of Real Estate",
    documentProperties: "Explore Properties",
    documentProjectDetails: "Project Details",
    documentFaq: "FAQ",
  },

  language: {
    changeLanguage: "Change Language",
  },

  profile: {
    faqCategories: "Categories",
    faqSearchPlaceholder: "Search",
    faqCantFind: "Can't find what you're looking for?",
    faqRaiseRequest: "Raise Request",
    popularQuestions: "Popular questions",
    faqEmptyTitle: "No FAQs available",
    faqEmptySubtitle: "Please check back later.",
    faqSearchNoResultsTitle: "No FAQs found.",
    faqSearchNoResultsSubtitle: "Try searching with a different keyword.",
    faqQuestionLabel: "Q.",
    faqAnswerLabel: "A.",
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    phoneNumber: "Phone number",
    emailRequired: "Email",
    enterPhoneNumber: "Enter phone number",
    enterEmailAddress: "Enter email address",
    searchCountryOrCode: "Search country or code...",
    selectCountry: "Select Country",
    hello: "Hello!",
    detailsDescription:
      "We found your details in our record, please confirm before you get started",
    fetchError: "Failed to fetch profile details. Please try again.",
    myProfile: "My Profile",
    appLanguage: "App language",
    personalDetails: "Personal details",
    loanDetails: "Loan details",
    loanDetailsSubtitle: "Application number, Sanctioned loan amount",
    applicationNumber: "Application number",
    sanctionedLoanAmount: "Sanctioned loan amount",
    loginEmailId: "Login email id",
    loginEmailCannotBeChanged: "This email id cannot be changed",
    communicationEmailId: "Communication email id",
    communicationEmailDescription:
      "You'll receive all communications from Bloom to this email ID",
    phoneNumberEmail: "Phone number, Email",
    customerId: "Customer ID",
    adhaApplication: "ADHA Application",
    idProofs: "ID proofs",
    emiratesIdAndPassport: "Emirates ID and Passport",
    and: " and ",
    passport: "Passport",
    emiratesId: "Emirates ID",
    view: "View",
    update: "Update",
    noIdProofsAvailable: "No ID proofs available",
    noDocumentsAvailable: "No documents available",
    passcodePassword: "Passcode, Password",
    faq: "FAQ",
    customerSupport: "Customer support",
    logOut: "Log Out",
    logoutConfirmation: "Are you sure you want to log out?",
    logoutError: "We couldn't log you out. Please try again.",
    copyApplicationNumber: "Copy application number",
    applicationNumberCopied: "Application number has been successfully copied.",
    applicationNumberCopyFailed:
      "Unable to copy the application number. Please try again.",
    profileLoadError:
      "We're unable to load your profile information. Please try again later.",
    personalDetailsLoadError:
      "We're unable to load your personal details. Please try again later.",
    personalDetailsNetworkError:
      "We're unable to load your personal details. Please check your connection and try again.",
    loanDetailsLoadError:
      "We're unable to load your loan details. Please try again later.",
    loanDetailsNetworkError:
      "Unable to load your loan details. Please check your connection and try again.",
    loanDetailsInvalid:
      "We couldn't display your loan details. Please try again later.",
    loggedOutSuccessfully: "Logged out\nsuccessfully",
    goToLogin: "Go to login",
    accountSecurity: "Account & Security",
    // Privacy & Security (flattened under profile)
    privacyTitle: "Privacy and security",
    privacyPasscodeSection: "Passcode",
    privacyPasscode: "Passcode",
    privacyLoginSection: "Login",
    privacyChangePassword: "Change password",
    changePasswordDescription: "Click here to change your account password",
    deactivate: "Delete",
    deactivateDescription:
      "Delete your account will disable access to the app. You can request reactivation through customer support.",
    deactivateConfirmationTitle:
      "Are you sure you want to delete your account?",
    deactivateAccount: "Delete Account",
    // Passcode keys (flattened under profile)
    passcodeEnterPasscode: "Enter passcode",
    passcodeConfirmPasscode: "Confirm passcode",
    passcodeEnterOldPasscode: "Enter old passcode",
    passcodeEnterNewPasscode: "Enter new passcode",
    passcodeEnableBiometric: "Enable biometric",
    passcodeSkipPasscode: "Skip passcode",
    passcodeResetPasscode: "Reset passcode",
    passcodeResetConfirmation:
      "Are you sure you want to reset your passcode? This will log you out; you will need to log in and set it up again.",
    passcodeResetSuccess: "Passcode has been reset successfully.",
    passcodeResetError: "Failed to reset passcode. Please try again.",
    passcodeSetSuccess: "Passcode set successfully",
    passcodeChangeSuccess: "Passcode changed successfully",
    passcodeSkipSuccess: "Passcode setup skipped",
    passcodeSetError: "Failed to set passcode. Please try again.",
    passcodeVerifyError: "Failed to verify passcode. Please try again.",
    passcodeChangeError: "Failed to change passcode. Please try again.",
    passcodeSkipError: "Failed to skip passcode. Please try again.",
    passcodeMismatch: "Passcodes do not match. Please try again.",
    passcodeOldInvalid: "Old passcode is incorrect. Please try again.",
    passcodeRemoveConfirmation: "Are you sure you want to remove passcode",
    passcodeRemovedTitle: "Passcode removed.",
    passcodeRemovedMessage: "You can always set it again anytime.",
    privacyChangePasscode: "Change passcode",
    privacyEnableBiometric: "Enable biometrics",
    privacyRemoveBiometric: "Remove biometrics",
    biometricRemoveConfirmation: "Are you sure you want to remove biometrics",
    biometricRemovedTitle: "Biometrics removed.",
    biometricRemovedMessage: "You can always enable it again anytime.",
    biometricEnabledTitle: "Biometrics enabled.",
    biometricEnabledMessage:
      "You can use biometric authentication to unlock the app.",
  },

  registration: {
    hello: "Hello!",
    detailsDescription: "We just need a few details to get you started",
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    termsPrefix: "By continuing you agree to our ",
    termsLink: "Terms & Conditions",
    andText: "and acknowledge that you have read our",
    privacyLink: "Privacy Policy",
    enterValidEmail: "Please enter a valid email address",
    emiratesIdNumber: "Emirates ID Number",
    passportNumber: "Passport Number",
    email: "Email",
    nationality: "Nationality",
    selectNationality: "Select Nationality",
    searchNationality: "Search nationality",
    enterHere: "Enter here",
    phoneNumber: "Phone number",
    enterPhoneNumber: "Enter phone number",
    alreadyRegistered: "You are already registered. Please log in to continue.",
    registrationCannotBeProcessed:
      "Registration cannot be processed at the moment. Please check if the provided details are correct.",
  },

  documentCapture: {
    title: "Take a photo of your Passport",
    subtitle: "",
    instructions: "Use original Emirates ID only",
    captureButton: "Capture",
    flashOn: "Flash On",
    flashOff: "Flash Off",
    retakePhoto: "Retake Photo",
    usePhoto: "Use Photo",
    goodLighting: "Take the photo in good lighting",
    clearDetails: "Make sure details are clear",
    scanning: "Scanning...",
    scanningInProgress: "Scanning document, please hold steady",
    documentDetected: "Document detected",
    positionDocument: "Position your document within the frame",
    scanError: "Scan Error",
    scanErrorMessage: "Failed to scan document. Please try again.",
    scanSuccess: "Document scanned successfully",
    autoCapture: "Auto Capture",
    manualCapture: "Manual capture",
    documentNotDetected: "Document not detected",
    holdSteady: "Hold steady while scanning",
    passportDetected: "Passport detected! Hold steady...",
    placePassportInFrame: "Place passport within the frame",
    placePassportHere: "Place your passport here",
    confidence: "Confidence",
    validationFailed: "Validation Failed",
    captureFailed: "Capture failed. Please try again.",
    scanFailed: "Scan failed. Please try again.",
    scannerNotAvailable: "Scanner not available on this device.",
    instruction1: "Place your passport within the frame",
    instruction2: "Ensure good lighting and clear visibility",
    instruction3: "Hold steady when passport is detected",
    placePassport: "Place your passport here",
    tapToScan: "Tap to scan your document",
    scanDocument: "Scan Document",
    titleEmiratesIdFront: "Take a photo of the FRONT of your Emirates ID",
    titleEmiratesIdBack: "Take a photo of the BACK of your Emirates ID",
    titlePassport: "Take a photo of your Passport",
    instructionUseOriginalEmiratesId: "Use original Emirates ID only",
    instructionUseOriginalPassport: "Use original passport only",
    instructionGoodLighting: "Take the photo in good lighting",
    instructionClearDetails: "Make sure details are clear",
    cameraPermissionRequired: "Camera permission required",
    cameraPermissionMessage: "Please grant camera permission to scan documents",
    grantPermission: "Grant Permission",
    cameraNotAvailable: "Camera not available",
  },

  documentViewer: {
    clear: "Clear",
    passport: "Passport",
    previewTitlePassport: "Passport ID picture",
    previewTitleEmiratesId: "Emirates ID picture",
    uploadTitle: "Upload emirates id",
    uploadSubtitle: "Take photo of your emirates id to verify your identity",
    uploadTitlePassport: "Upload passport",
    uploadSubtitlePassport:
      "Take photo of your passport to verify your identity",
    note: "Note",
    noteText:
      "Use original Emirates ID only. Take the photo in good lighting. Make sure details are clear.",
    noteTextPassport:
      "Use original passport only. Take the photo in good lighting. Make sure details are clear.",
    front: "Front",
    back: "Back",
    frontSide: "Front side",
    backSide: "Back side",
    passportSide: "Passport",
    capture: "Capture",
    edit: "Edit",
    uploading: "Uploading...",
    uploaded: "Uploaded",
    uploadError: "Upload failed",
  },

  documentReview: {
    title: "Almost done. Please confirm your details",
    firstName: "First name",
    middleName: "Middle name",
    lastName: "Last name",
    email: "Email",
    phoneNumber: "Phone number",
    emiratesIdNumber: "Emirates ID number",
    emiratesIdPicture: "Emirates ID (picture)",
    passportNumber: "Passport number",
    passportPicture: "Passport (picture)",
    preview: "Preview",
    submit: "Submit",
  },

  dialogs: {
    editPhoneConfirmation: "Are you sure you want to edit your phone number?",
    editEmailConfirmation:
      "This email id will be used to login to the app, are you sure you want to change this?",
    changePhoneConfirmation:
      "Are you sure you want to change your phone number?",
    changeEmailConfirmation:
      "Are you sure you want to change your email address?",
    yes: "Yes",
    no: "No",
  },

  errors: {
    networkError:
      "No internet connection. Please check your network and try again.",
    serverError: "Server error. Please try again later.",
    validationError: "Please check your input and try again.",
    unknownError: "An unknown error occurred.",
    fillAllFields: "Please fill in all fields",
    loginFailed: "Login failed. Please try again.",
    registrationFailed: "Registration failed. Please try again.",
    pageNotFound: "Page Not Found",
    pageNotFoundDescription:
      "The page you're looking for doesn't exist, may have been moved, or the URL might be incorrect.",
    backToHome: "Back to Home",
  },

  home: {
    goodMorning: "Good Morning",
    goodAfternoon: "Good Afternoon",
    goodEvening: "Good Evening",
    goodNight: "Good Night,",
    totalProperties: "Total properties",
    purchasePrice: "Purchase price",
    missedPayments: "Missed payments",
    paymentsDueIn30Days: "Payments due in 30 days",
    paymentUpdates: "Payment updates",
    bloomVentures: "Bloom Ventures",
    inProcess: "In process",
    paymentConfirmed: "Payment confirmed",
    hello: "Hello",
    exclusiveListingsForYou: "Exclusive listings for you",
    tabLabel: "Home",
  },

  payments: {
    tabLabel: "Payment",
    title: "Payments",
    propertyPayments: "Property payments",
    serviceChargePayments: "Service charge payments",
    property: "property",
    properties: "properties",
    community: "community",
    cheque: "cheque",
    cheques: "cheques",
    chequesAvailable: "Cheques available",
    lastPayment: "Last payment",
    upcoming: "Upcoming",
    inProcessPayments: "In Process Payments",
    statusPaid: "Paid",
    statusDueSoon: "Due soon",
    payViaBankToBloom: "You can pay via Bank to Bloom",
    history: "History",
    allProperties: "All Properties",
    propertiesSelected: "Properties selected",
    selectProperties: "Select Properties",
    searchPropertiesPlaceholder: "Type property name/Project name",
    save: "Save",
    filter: "Filter",
    missedPayments: "Missed payments",
    dueIn30Days: "Due in 30 days",
    totalOutstanding: "Total outstanding",
    dueSoonPayments: "Due soon payments",
    futurePayments: "future payments",
    noPaymentHistory: "No payment history available",
    total: "Total",
    paymentSelected: "payment selected",
    paymentsSelected: "payments selected",
    excludingTaxes: "Excluding taxes",
    cancel: "Cancel",
    paymentSummary: "Payment summary",
    paymentBreakdown: "Payment breakdown",
    feesAndCharges: "Fees and charges",
    latePaymentFee: "Late payment fee",
    convenienceFee: "Technology fee",
    excludingCardProcessingFee: "Excluding card processing fee",
    cardProcessingFee: "Card processing fee",
    estimatedCardProcessingFee: "Estimated card processing fee",
    domesticCards: "Domestic cards",
    internationalCards: "International cards",
    termsAndConditions: "Terms & conditions",
    pay: "Pay",
    septemberInstalment: "September instalment",
    octoberInstalment: "October instalment",
    dueBy: "Due by",
    supportButtonPressed: "Support button pressed",
    payNowPressed: "Pay now pressed",
    termsPressed: "Terms & conditions pressed",
    paymentFailedTitle: "Your payment has failed",
    paymentFailedDescription:
      "We unable to process your payment. Please retry paying or try after some time.",
    paymentTemporaryIssue:
      "We're unable to process your payment ({{paymentNames}}) due to a temporary issue. Please try again later.",
    paymentErrorCode: "Error: D61-Refer to card issuer",
    paymentCancelledTitle: "Payment cancelled",
    paymentCancelledDescription:
      "You cancelled the payment. You can try again when you're ready.",
    paymentSuccessTitle: "Your payment was successful",
    paymentSuccessDescription:
      "Receipt will be generated after we have processed the payment. This may take up to 5 working days.",
    paymentPendingTitle: "Your payment is being processed",
    transactionId: "Transaction Id",
    transactionIdCopied: "Transaction ID copied",
    chequeNotice:
      "This property has cheques waiting to be cleared. In order to collect or shred cheques, please contact customer support",
    raiseChequeShredRequest: "Raise cheque shred request",
    raiseChequeShredRequestPressed: "Raise cheque shred request pressed",
    paymentDetails: "Payment details",
    autoDeductionNotice: "Payment will be auto deducted via cheque on file",
    receiptGenerationNotice:
      "Receipt will be generated after we have processed the payment. This may take up to 5 working days.",
    proFormaInvoiceQuestion: "Do you want a pro forma invoice?",
    installmentNumber: "Installment no #{number}",
    viewReceipt: "View receipt",
    downloadInvoice: "Download",
    percentOfTotalAmount: "% of total amount",
    onlinePaymentFeeNotice:
      "Paying online will incur a cheque withdrawal/cancellation fee",
    paymentNotFound: "Payment not found",
    type: "Type",
    dueDate: "Due date",
    totalAmount: "Total amount",
    raiseRequest: "Raise request",
    payNow: "Pay now",
    viewBankDetails: "View Bank Details",
    paidAmount: "Paid amount",
    remainingAmount: "Remaining amount",
    reportIssue: "Report an issue",
    retry: "Retry",
    tryAgain: "Try again",
    checkingPaymentStatus: "Checking payment status...",
    pendingPaymentNotification:
      "We will notify you once your payment is processed.",
    backToHome: "Back to home",
    retryPressed: "Retry button pressed",
    tryAgainPressed: "Try again button pressed",
    reportIssuePressed: "Report issue button pressed",
    paymentCheckout: "Payment Checkout",
    redirectingToPayment: "Redirecting to payment gateway...",
    noPaymentsSelected: "No payments selected",
    noUpcomingPayments: "No upcoming {type} payments",
    emptyStateTitleProperty: "You're all caught up with property payments!",
    emptyStateTitleCommunity: "You're all caught up with community payments!",
    emptyStateSubtitle: "You have no upcoming payments.",
    historyEmptyStateTitle: "Uh Oh! Looks empty",
    historyEmptyStateSubtitle:
      "Please make a payment through the app to view history",
    accountStatement: "Account statement",
  },
  properties: {
    tabLabel: "My properties",
    myProperties: "My properties",
    constructionCompleted: "Construction completed",
    installmentPaid: "Installment paid",
    subtitle: "Here's quick access to your properties, payments, and more.",
    hello: "Hello",
    noPropertiesFound: "No properties found",
    noPropertiesYetTitle: "No Properties Yet",
    noPropertiesYetSubtitle: "There are currently no properties to display.",
    missedPayment: "Missed payment",
    missedPayments: "Missed payments",
    paymentDueSoon: "{count} Payment due in 30 days",
    paymentsDueSoon: "{count} Payments due in 30 days",
    noPendingDues: "No pending dues",
    priceRange: "Price Range",
    loanAmount: "(Iskan loan)",
    millionAbbrev: "M",
    sqFt: "sq ft",
    loanEligibility: "Your selection is {{loanStatus}} your loan eligibility.",
    above: "above",
    within: "within",
    availableLoanAmountNote: "Your available Iskan loan amount is {{loanAmount}}.",
    selectCategory: "Select Category",
    applyFilter: "Apply Filter",
    projectDetails: "Project Details",
  },
  propertyDetails: {
    title: "Property details",
    unitDetails: "Unit details",
    aboutUnit: "About Unit",
    unitInfo: "Unit info",
    yourFabPreApproval: "Your FAB pre-approval",
    fabPreApprovalCoversUnit: "covers this Unit",
    brochure: "Brochure",
    masterPlan: "Master Plan",
    discoverMasterPlan: "Discover {{projectName}}'s Master Plan",
    view: "View",
    brochureNotAvailable: "Brochure not available for this property.",
    brochureDownloadFailed: "Failed to download brochure. Please try again.",
    documentSaveFailed: "Failed to save file. Please try again.",
    customerIdNotAvailable: "Customer ID not available.",
    imInterested: "I'm Interested",
    totalPrice: "Total Price",
    noPropertyData: "No property data available",
    addressingNumber: "Addressing number",
    addressingNumberCopied: "Addressing number copied",
    failedToCopy: "Failed to copy",
    spaAvailable:
      "Sales and Purchase Agreement is available for download from documents",
    paymentCompleted: "Payment completed",
    amountOutstanding: "Amount outstanding",
    chequeAvailable: "Cheque Available",
    chequeAvailableDescription:
      "You have cheques against this property. Raise request to shred them",
    raiseRequest: "Raise request",
    aboutProperty: "About property",
    propertyInfo: "Property info",
    bedrooms: "Bedrooms",
    bathrooms: "Bathrooms",
    areaInSqFt: "Area in sq ft",
    viewFloorPlan: "View floor plan",
    amenities: "Amenities",
    documents: "Documents",
    documentsAvailable: "{count} documents available",
    fileDownloadedWithName: "File downloaded successfully: {{fileName}}",
    folderSelectionCancelled: "Folder selection was cancelled. Please choose a folder (e.g., Downloads) to save the file.",
    iosNoWritableDirectory: "No writable directory available on iOS",
    iosSaveHint: "Tap Share and choose “Save to Files” to pick a folder.",
    documentsListTitleDeed: "Title deed",
    documentsListSpa: "SPA document",
    documentsListFloorPlan: "Floor plan",
    documentsListPassport: "Passport",
    documentsListEidFront: "Emirates ID (Front)",
    documentsListEidBack: "Emirates ID (Back)",
    documentsListAccountStatement: "Account statement",
    documentsListReceiptHistory: "Receipt history",
    ownerDetails: "Owner details",
    share: "Share",
    primary: "Primary",
    payments: "Payments",
    missed: "Missed",
    dueIn30Days: "due in 30 days",
    upcoming: "Upcoming",
    history: "History",
    property: "Property",
    community: "Community",
    paymentHistory: "Payment History",
    missedPayments: "{count} Missed Payments",
    noPayments: "No {type} payments",
    noPaymentHistory: "No {type} payment history",
    paymentsDueIn30Days: "+ {count} payments due in 30 days",
    viewMore: "View more",
    viewAll: "View all",
    accountStatement: "Account statement",
    paySelected: "Pay selected",
    dueBy: "Due by",
    handover: "Handover",
    installment: "Installment",
    downPayment: "Down Payment",
    admFee: "ADM Fee",
    noPaymentsSelected: "No payments selected",
    bhkFlat: "{bedrooms} BHK flat, {amenitiesCount} amenities",
    amenitiesCount: "{count} amenities",
    aed: "AED",
    floorPlanUnavailableError: "Property or customer unavailable",
    floorPlanOpenError: "Unable to open floor plan",
    floorPlanSaveError: "Failed to save floor plan",
    openMapsError: "Failed to open maps application.",
    chooseNextStep: "Choose Your Next Step",
    bookAppointmentTitle: "Book an Appointment",
    bookAppointmentDescription:
      "Visit the Unit at a convenient time to explore it in person and discuss the details with a sales representative.",
    bookAppointmentCta: "Book Appointment",
    appointmentBookingSuccess:
      "Appointment Booking request raised successfully!",
    reserveUnitTitle: "Reserve Unit",
    reserveUnitDescription:
      "Reserve your preferred Unit to begin the reservation process and move one step closer to ownership.",
    reserveUnitCta: "Reserve Unit",
    viewReservationCta: "View Reservation",
    unitReservationSuccess: "Unit Reservation request raised successfully!",
    viewAppointmentCta: "View Appointment",
    appointmentConfirmedTitle: "Appointment Confirmed",
    date: "Date",
    time: "Time",
    contactPersonName: "Account Manager",
    phoneNumber: "Phone Number",
    reschedule: "Reschedule",
    cancelAppointment: "Cancel Appointment",
    cancelAppointmentRequest: "Cancel Request",
    appointmentCanceledSuccess: "Appointment canceled successfully.",
    handoverDateLabel: "Handover date",
    handoverDateWithDate: "Handover date: {date}",
    constructionCompletedPercent: "Construction completed {percent}%",
    unitPriceLabel: "Unit Price",
    outstandingBalance: "Outstanding Balance",
    payNow: "Pay Now",
    completePaymentTitle: "Complete Your Payment",
    approvedIskanLoan: "Approved Iskan Loan",
    howWouldYouLikeToProceed: "How would you like to proceed?",
    bankTransfer: "Bank Transfer",
    bankTransferDescription: "Pay directly to the provided account",
    proofOfMortgage: "Proof of Mortgage",
    proofOfMortgageDescription: "Submit your mortgage approval",
    bankTransferDetailsTitle: "Bank Transfer Details",
    transferToThisAccount: "Transfer to this account",
    accountName: "ACCOUNT NAME",
    amountPaid: "AMOUNT PAID",
    bankName: "BANK NAME",
    accountNumber: "ACCOUNT NUMBER",
    iban: "IBAN",
    swiftCode: "SWIFT CODE",
    bankTransferNotePrefix: "Please ensure that you send the payment proof to",
    bankTransferNoteProof: "payment proof",
    bankTransferNoteEmailConnector: " to ",
    bankTransferNoteEmail: "",
    iveMadeTheTransfer: "I've Made the Transfer",
    copiedToClipboard: "Copied to clipboard",
    submissionReceivedTitle: "Submit Your Proof",
    submitProofPaymentInstruction: "Please email your proof of payment to:",
    submitProofMortgageInstruction: "Please email your proof of mortgage to:",
    submitProofReviewNote: "Our team will review and confirm your payment.",
    submitProofEmail: "xyz@bloomholding.com",
    backToUnitDetails: "Back to Unit Details",
    iskanLoanCoversTemplate: "{amount} covers this Unit",
    iskanLoanCoversVerb: "covers",
    iskanLoanCoversUnitSuffix: "this Unit",
    unitLoadError:
      "We're unable to load the unit details. Please try again later.",
    documentDownloadFailed:
      "Unable to download the document. Please try again.",
  },
  reserveUnit: {
    confirmTitle: "Confirm your reservation",
    confirmSubtitle:
      "Review the details below to reserve this unit. Once submitted, a booking form will be sent to you via email.",
    totalUnitPrice: "Total Unit Price",
    iskanLoan: "Iskan loan",
    remainingBalance: "Remaining Balance",
    importantToNote: "Important to Note",
    importantNoteBody:
      "The unit price exceeds your approved loan coverage. The remaining balance must be paid separately.",
    whatHappensNext: "What happens next?",
    stepEmail: "You will receive a booking form to sign via Email",
    stepDeadline:
      "Sign the booking form within 15 days to keep your reservation active.",
    proceedCta: "Proceed to Reserve",
    unitReservedTitle: "Unit Reserved",
    unitReservedCongrats: "Congratulations!",
    unitReservedMessage:
      "Your unit has been reserved. You're one step closer to ownership. The booking form will be shared via email shortly.",
    pendingBadge: "Pending",
    awaitingSignatureNote: "Awaiting Signature",
    reservationSummaryTitle: "Reservation Summary",
    requestedOn: "Requested on",
    status: "Status",
    resendEmailNote:
      "Didn't receive the email? Please check your spam folder or request a new Email.",
    cancelReservation: "Cancel Reservation",
    cancelReservationConfirmMessage:
      "Are you sure you want to cancel your reservation?",
    resendEmail: "Resend Email",
    emailResentSuccess: "Email resent successfully!",
    reservationCanceledSuccess: "Reservation canceled successfully.",
    reservationCanceledTitle: "Reservation Canceled",
    reservationCanceledMessage:
      "Your reservation has been successfully cancelled.",
    unitAlreadyReservedError:
      "This unit is no longer available. Please browse other available units.",
    submissionFailedError:
      "We're unable to process your reservation at the moment. Please try again later.",
    resendEmailError:
      "We're unable to resend the email right now. Please try again later.",
    cancelReservationError:
      "We're unable to cancel your reservation at the moment. Please try again later.",
    reservationPending: "Reservation Pending",
    reservationInProgress: "Reservation In Progress",
    reservationConfirmed: "Reservation Confirmed",
    checkEmailTitle: "Check Your Email",
    reservedBannerTitle: "Reserved!",
    proceedShortfallCta: "Proceed",
    activeReservationToast:
      "You already have an active reservation. You can cancel your previous reservation and reserve as only one ADHA unit can be reserved at a time.",
    activeReservationListingToast:
      "You already have an active reservation. You can reserve only one ADHA property.",
    reservationStatus: {
      customerSignedBookingForm: "Booking Form Signed",
      opportunityNotCreated: "Reservation Form Sent",
      opportunityCreated: "Reservation Form Sent",
      awaitingReservationFormCustomer: "Reservation Form Sent",
      awaitingReservationFormBloom: "Reservation Form Sent",
      reservationFormSigned: "Reservation Form Signed",
      decreeApproval: "Reservation Form Sent",
      spaAwaitingCustomer: "Awaiting SPA Signature",
      spaAwaitingBloom: "Awaiting Bloom SPA Signature",
      spaSigned: "SPA Signed",
      unknownReserved: "Reservation Form Sent",
    },
    reservationVisible: {
      inProgressListing: "In Progress",
      processingApplication: "Reservation Form Sent",
      awaitingYourSignature: "Awaiting Signature",
      awaitingBloomHoldingSignature: "Awaiting Bloom SPA Signature",
      reservationConfirmedListing: "Reservation Confirmed",
      bookAppointmentToContinue: "Booking Form Signed",
      reservationFormSent: "Reservation Form Sent",
      reservationFormSigned: "Reservation Form Signed",
      awaitingSpaSignature: "Awaiting SPA Signature",
      awaitingBloomSpaSignature: "Awaiting Bloom SPA Signature",
      spaSigned: "SPA Signed",
      bookingFormSigned: "Booking Form Signed",
    },
  },
  bookAppointment: {
    title: "Book an Appointment",
    slotDate: "Slot Date",
    slotTime: "Select Time Slot",
    slotSubtitle: "Choose a convenient date and time to visit Bloom office.",
    today: "Today",
    tomorrow: "Tomorrow",
    bookAppointment: "Book Appointment",
    reschedule: "Reschedule Appointment",
    requestRaised: "Appointment Booking request raised successfully!",
    upcomingAppointment: "Upcoming Appointment",
    visitOffice: "Visit Office",
    joinHere: "Join Online",
    cancelMessage: "Are you sure you want to cancel your appointment?",
    canceledTitle: "Appointment Cancelled",
    canceledMessage: "Your appointment has been successfully cancelled.",
    slotsEmpty: "No Slots Available !",
    slotsError: "Unable to load time slots. Please try again.",
    slotsNoneAvailable:
      "No appointment slots are currently available. Please try again later.",
    slotNoLongerAvailable:
      "This appointment slot is no longer available. Please select another available slot.",
    bookError:
      "We're unable to book your appointment at the moment. Please try again later.",
    rescheduleError:
      "We're unable to reschedule your appointment at the moment. Please try again later.",
    cancelError:
      "We're unable to cancel your appointment at the moment. Please try again later.",
  },
  notifications: {
    title: "Notifications",
    upToDate: "You are up to date!",
    count: "Notifications",
    clearAll: "Clear All",
  },
  support: {
    title: "Support",
    subtitle: "Hi {{name}}! How can I help you?",
    raiseRequest: "Raise Request",
    history: "History",
    createTitle: "Tell us your issue",
    createSubtitle: "Hi {{name}}! How can I help you?",
    selectUnitLabel: "Select Unit",
    selectUnitPlaceholder: "Choose your unit",
    selectCategoryLabel: "Select Category",
    selectCategoryPlaceholder: "Choose a category",
    describeIssueLabel: "Describe your issue",
    describeIssuePlaceholder: "Describe your issue here",
    submitRequestCta: "Submit Request",
    requestCallbackCta: "Request a call back",
    emailLabel: "Email",
    emailPlaceholder: "Enter your email",
    phoneLabel: "Phone number",
    phonePlaceholder: "Enter your phone number",
    countryCodePlaceholder: "Code",
    successTitle: "Request submitted",
    successSubtitle:
      "We have received your request and will get back to you soon.",
    guestNameFallback: "there",
    errorSelectUnit: "Please select a unit",
    errorSelectCategory: "Please select a category",
    errorDescribeIssue: "Please describe your issue",
    errorEmail: "Please enter a valid email",
    errorPhone: "Please enter your phone number",
    inProgress: "In progress",
    resolved: "Resolved",
    emptyState: "No service requests found",
    // Details (flattened)
    detailsTitle: "Issue details",
    detailsUnit: "Unit",
    detailsCategory: "Category",
    detailsSubCategory: "Sub category",
    detailsIssueDescription: "Issue description",
    detailsStatus: "Status",
    detailsCaseNumber: "Case number",
    detailsCreatedOn: "Created on",
    detailsDescription: "Description",
    detailsNoDescription: "No description provided",
    detailsUpdates: "Updates",
    detailsNoUpdates: "No updates yet",
    detailsContactSupport: "Contact support",
    detailsUpdateTeamContacted: "Bloom team contacted you",
    detailsUpdateInProgress: "Customer support is looking into the issue",
    detailsUpdateRaised: "Request raised",
  },
  propertiesWeb: {
    title: "Properties",
    list: {
      greetingPrefix: "Good Morning",
      millionAbbrev: "M",
      oneMillion: "1 M",
      twoMillion: "2 M",
      threeMillion: "3 M",
      sixMillion: "6 M",
      emptyNoProperties:
        "No ADHA properties are currently available. Please check again later.",
      emptyFilterNoMatch:
        "No properties found for the selected price range and filters. Please adjust your filters to view more options.",
      emptyFetchError:
        "We're unable to load the property listings at the moment. Please try again later.",
      projectDetailsTab: "Project Details",
      exploreUnitsTab: "Explore Units",
      exploreUnitsTitle: "Explore Units",
      associatedUnits: "Available Units",
      filters: {
        openFilters: "Open filters",
        title: "Filters",
        close: "Close filters",
        unitNumber: "Unit number",
        unitNumberPlaceholder: "Enter unit number",
        matchingUnits: "Matching units",
        noMatchingUnits: "No units match this number",
        numberOfBedrooms: "Number of bedrooms",
        bedroomsHint: "Choose one or more",
        bedroomsShort: "{{count}} BR",
        bedroomOption: "{{count}}BR",
        selectBedrooms: "Select bedrooms",
        apply: "Apply",
        cluster: "Cluster",
        clusterPlaceholder: "Select cluster",
        clearAll: "Clear all",
        applyFilter: "Apply Filter",
      },
    },
  },
  guestWeb: {
    unitDetails: "Project Details",
    breadcrumbHome: "Home",
    breadcrumbUnitDetails: "Project details",
    exploreProperties: "Explore Properties",
    aboutProperty: "About Property",
    documents: "Documents",
    brochure: "Brochure",
    numberOfUnits: "Number of Units",
    unitType: "Unit type",
    amenities: "Amenities",
    login: "Login",
    maybeLater: "Maybe later",
    loginPromptTitle: "Login",
    loginPromptMessage: "Log in to view full property details.",
    emptyNoProperties:
      "No properties are currently available. Please check again later.",
    emptyFetchError:
      "We're unable to load the property listings at the moment. Please try again later.",
    exploreEmpty: "No other properties to explore right now.",
    unitsBadge: "{{count}} Units",
    greeting: "{{greeting}} !",
  },
  bloomUniversal: {
    spaceComingSoon: "This Bloom space page is coming soon.",
    backToSpaces: "Back to Bloom spaces",
    breadcrumbHome: "Home",
    discoverMore: "Discover more",
    callSupport: "Call Bloom support",
    call: "Call",
    exploreEyebrow: "EXPLORE BLOOM WORLD",
    exploreBody:
      "Discover the communities, experiences and services that shape everyday life.",
    exploreTitle: "Explore Bloom World",
    exploreSubtitle:
      "Discover the communities, experiences and services that shape everyday life.",
  },
  ventures: {
    website: "Website",
    contact: "Contact",
  },
  bloomExperience: {
    label: "THE BLOOM EXPERIENCE",
    heroTitle: "More Than a Place to Live.",
    heroSubtitle: "A Bloom Way of Life.",
    getStarted: "Let's Get Started",
    exploreTitle: "EXPLORE BLOOM WORLD",
    exploreSubtitle:
      "Discover the communities, experiences and services that shape everyday life.",
    facilitiesManagement: "Bloom Facilities\nManagement",
    hospitality: "Bloom Hospitality",
    properties: "Bloom Properties",
    retail: "Bloom Retail",
    education: "Bloom Education",
    landscape: "Bloom Landscape",
    // Details screen (reached by tapping a card) — single-line title variant,
    // separate from facilitiesManagement above which hardcodes a line break
    // for the card grid's own layout.
    facilitiesManagementTitle: "Bloom Facilities Management",
    discoverMore: "Discover more",
    keyInstitutions: "Key Institutions",
    facilitiesManagementDescription:
      "We deliver comprehensive facilities and community management services, keeping every Bloom community safe, clean, and well maintained.",
    hospitalityDescription:
      "We bring exceptional hospitality experiences to life, operating world-class hotels and leisure destinations across the UAE.",
    propertiesDescription:
      "We design and deliver thoughtfully master-planned communities, offering a range of homes across Abu Dhabi's most sought-after destinations.",
    retailDescription:
      "We curate vibrant retail and dining destinations that bring convenience, community, and lifestyle together.",
    educationDescription:
      "We are a leading education provider, shaping future generations through world-class schools, nurseries, and education partnerships across the UAE.",
    landscapeDescription:
      "We create and maintain lush, sustainable green spaces that bring Bloom communities to life.",
  },
} as unknown as TranslationKeys;
